import React from 'react'
import { GenericError } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import zionDebug from '@fs/zion-debug'
import useAnonSession from './useAnonSession'

// turn on in browser console with: localStorage.debug = 'fs:search:auth:*'
const debug = zionDebug('search:auth:anonSessionGate')

export const redirectToLogin = () => {
  window.location.replace(`/auth/familysearch/login?returnUrl=${encodeURIComponent(window.location)}`)
}

/**
 * Bootstrap an anonymous session before rendering a route — the Platform API requires a session.
 * A signed-in user already has one, so a failed anonymous bootstrap never blocks them; anonymous
 * users are sent to login when a session can't be started.
 */
const AnonSessionGate = ({ LoadingSkeleton, children }) => {
  const { userLoading, signedIn } = useUser()
  const { loading, error } = useAnonSession()

  if (signedIn) return children

  if (error) {
    // Not signed in *yet* — wait for the user check before treating the failure as fatal.
    if (userLoading) return LoadingSkeleton || null
    debug('Could not get anonymous session. Requiring sign in.')
    redirectToLogin()
    return <GenericError /> // user shouldn't get here; it's just here for testing purposes
  }

  // Show the skeleton during the anonymous-session bootstrap instead of a blank page.
  if (loading) return LoadingSkeleton || null

  return children
}

export default AnonSessionGate
